import { gql } from '@apollo/client';

export const CREATE_ASSESSMENT = gql`
  mutation createAssessment($data: CreateAssessmentInput!) {
    createAssessment(data: $data) {
      id
    }
  }
`;
